import fetch, { simpleFetch as fetcher } from '@api/fetchers';
import { getCMSHost } from '@utils/api-helper/host';

const CMSHost = getCMSHost();

export const getReferralFeedEndpoint = () =>
  'v2/subscriptions/referrals/feed?limit=20&offset=0';

export const getReferralsEndpoint = () =>
  'v2/subscriptions/referrals/?limit=100';

export const getReferralShareMessage = () =>
  fetcher(`${CMSHost}api/policies/referralShareMessageV2/`);

export const getIsSingularReferralLinkEnabled = () =>
  fetcher(`${CMSHost}api/policies/singularReferralLinkEnabled/`);

export const getReferralFeedbackData = () =>
  fetcher(`${CMSHost}api/policies/referralExitIntent/`);

export const getDiscountPercentData = () =>
  fetcher(`${CMSHost}api/general-experiments/default_referral_details/`);

export const getReferralUrl = (templateId, payload) =>
  fetch(`v2/subscriptions/referrals/shortlink/${templateId}`, {
    requestType: 'POST',
    body: payload
  });

export const getSingularReferralUrl = (payload) =>
  fetch('v1/subscriptions/referrals/url_shortner', {
    requestType: 'POST',
    body: payload
  });

export const getRewardDetailsEndpoint = () =>
  'v1/subscriptions/referrals/rewards';

export const getFreeReferralFeedEndpoint = () =>
  'v1/subscriptions/referrals/default_feed?limit=10&offset=0';

export const getReferralExitIntentEndpoint = () =>
  'v1/subscriptions/referrals/exit_intent/';
